import React from "react";

let Hero = React.createClass({
    getInitialState() {
        return {};
    },
    render() {
        return (
            <section className={["eo-hero", this.props.className].join(" ")}>
                <div className="eo-hero-content">
                    {this.props.children}
                </div>
            </section>
        );
    }
});

export default Hero;



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/components/Hero.js
 **/